import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Line } from 'vue-chartjs';
let LineChart = class LineChart extends Mixins(Line) {
    get options() {
        return {
            maintainAspectRatio: false,
            responsive: true,
            layout: {
                padding: 10,
            },
            elements: {
                line: {
                    tension: 0.1,
                },
            },
        };
    }
    mounted() {
        this.renderChart(this.dataset, this.options);
    }
};
__decorate([
    Prop({ type: String, default: 'rgba(0, 164, 184, 0.6)' })
], LineChart.prototype, "backgroundColor", void 0);
__decorate([
    Prop({ type: String, default: 'Default Label' })
], LineChart.prototype, "label", void 0);
__decorate([
    Prop({ type: Object, default: {} })
], LineChart.prototype, "dataset", void 0);
LineChart = __decorate([
    Component
], LineChart);
export default LineChart;
